module.exports = __webpack_public_path__ + "img/g_mro_1.989dd4e5.png";